/**
 * Truthiness guard. Returns `Boolean(value)` and narrows the type by removing
 * every falsy member TypeScript can name — `false`, `0`, `0n`, `''`, `null`,
 * `undefined` — so the narrowing matches the runtime check. (`NaN` is also
 * removed at runtime but cannot be expressed in the type.)
 *
 * Use this to state that you intentionally want truthiness, not a `null`/
 * `undefined` check. Because it drops all falsy values, reach for `isDefined`
 * instead when `0`, `''`, or `false` are valid values you must keep (e.g.
 * `latitude === 0`) — `isDefined` removes only `null`/`undefined`.
 *
 * e.g. `values.filter(isTruthy)` refines `(string | undefined)[]` to `string[]`.
 */
export function isTruthy(value) {
    return Boolean(value);
}
export function isDefined(value) {
    return value !== null && value !== undefined;
}
/**
 * Returns true when value is a non-null object — including arrays, since
 * `typeof [] === 'object'` in JavaScript and arrays satisfy NonNullable<object>.
 *
 * Kept in this dependency-free file (rather than in `types.ts`) so it can be
 * imported from contexts that load TypeScript via Node's strip-only loader
 * (e.g. Vite config files), which cannot parse the `enum` declarations that tend
 * to accumulate in a shared types module.
 */
export function isDefinedObject(value) {
    return isDefined(value) && typeof value === 'object';
}
//# sourceMappingURL=definedUtils.js.map